import React, { useState, useEffect } from "react";
import { toast } from "react-toastify"
import { Box, Typography, Divider, Button, Menu, MenuItem, Card, Tooltip, Modal } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import { esignIcons } from "../Esign/icons";
import { getStatusStyles } from "../../heplers";
import Loader from "../Loader";
import { apiEndpoint } from "../../urls";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";
import { refreshToken } from "../../store/reducers/pdfEditorTokenSlice";
import PdfPreview from "../PdfPreview/pdfPreview";
import { esignToolApi } from "../../services/esignApi";
import { useLogger } from "../../hooks/useLogger";
import QuickLookModal from "./QuickLookModal";
import SpeechTooltip from "./SpeechTooltip";

const DocumentDetails = ({doc, setSelectedDetailDoc, openDetails, setOpenDetails, signersStatus, handleDocumentDetails}) => {
  const logEvent = useLogger();
  const { open } = useOutletContext();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const navigate = useNavigate();
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDoc, setPreviewDoc] = useState({});
  const [selectedSigner, setSelectedSigner] = useState(null);
  const [openQuickLook, setOpenQuickLook] = useState(false);
  const [expireRequestOpen, setExpireRequestOpen] = useState(false);

  const handleSignerMenuOpen = (event, doc) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuOpen = (event, signer) => {
    setAnchorEl(event.currentTarget);
    setSelectedSigner(signer);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlesignerMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleExpire = async () => {
    logEvent('Clicked', 'Link Expired Click', 'Document Detail');
    handleMenuClose();
    if(selectedSigner?.uuid)
    {
      try {
        const response = await esignToolApi.expireLink(selectedSigner?.uuid);
        setLoader(false)
        console.log(response)
        if (response?.success) {
          handleDocumentDetails(doc);
          setExpireRequestOpen(false);
          toast.success("The credits used for this request will be added back to your account. Please note that the concerned signer will no longer be able to eSign this document.", {
            position: "bottom-center", autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined, style: { width: "650px" }});
        }
        else
        {
          setExpireRequestOpen(false);
          toast.error(response?.message || response?.error || "Failed to expire link.");
        }
      } catch (error) {
        setLoader(false)
        console.error("Error fetching data:", error);
      }
    }
  };
  
  const handleExpireOpen = () => {
    setExpireRequestOpen(true);
  }

  const handleSendReminder = async () => {
    logEvent('Clicked', 'Send Reminder Click', 'Document Detail');
    handleMenuClose();
    if(selectedSigner?.uuid)
    {
      try {
        const response = await esignToolApi.sendReminder(selectedSigner?.uuid);
        setLoader(false)
        console.log(response)
        if (response?.status) {
          toast.success(response?.message || "Reminder Sent successfully!");
        }
      } catch (error) {
        setLoader(false)
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleNewRequest = async () => {
    logEvent('Clicked', 'New Request Clicked', 'Document Detail');
    if(pdfEditortoken?.access && doc?.document_id)
    {
      setLoader(true)
      console.log(doc);

      try {

        const checkPendingEsign = await esignToolApi.checkPendingEsign(
          doc.document_id
        );
        console.log(checkPendingEsign)
  
        if (!checkPendingEsign.status) {
          console.error("checkPendingEsign:", checkPendingEsign);
          setLoader(false);
          return;
        }

        if (checkPendingEsign.status) {
          const response = await pdfToolApi.getSelectedDocuments(pdfEditortoken?.access, doc?.document_id, "" );
          setLoader(false)
          if (response.status) {
            console.log(response)
            const documentUrl = apiEndpoint.pdfBaseUri+response?.data?.document_url;

            if (!documentUrl) {
                console.error("Document URL not found in response.");
                return;
            }
            const checkResponse = await fetch(documentUrl, { method: 'HEAD' });
            if (!checkResponse.ok) {
                console.error(`Document not found: ${documentUrl}`);
                return;
            }


            const cloneSignerResponse = await esignToolApi.cloneSignerWithRequestId(
              doc.request_id,
              doc.document_id
            );
            console.log(cloneSignerResponse)
      
            if (!cloneSignerResponse.status) {
              console.error("Clone signer API failed:", cloneSignerResponse);
              setLoader(false);
              return;
            }
      
            console.log("Clone signer success:", cloneSignerResponse);
            // uploadFileFromUrl(documentUrl)
            // dispatch(clearUploadedDocument())
            // dispatch(setUploadedDocument(JSON.parse(localStorage.getItem("uploadedDocument"))));
            if (cloneSignerResponse.status) {
              const documentData = { data: response?.data, fullView: true };
              localStorage.setItem("uploadedDocument", JSON.stringify(documentData));
              navigate("/esign/pdfeditor", { replace: true }); 
            }
          }
        }
        else
        {
          toast.warning(checkPendingEsign?.message);
        }
      } catch (error) {
        setLoader(false)
        if (error.response?.status === 401 && error.response?.data?.code === "token_not_valid") {
          console.warn("Access token expired, attempting to refresh...");
          dispatch(refreshToken())
            .unwrap()
            .then((newTokenData) => {
              if (newTokenData.access) {
                handleNewRequest();
              }
            })
            .catch((refreshError) => {
              console.error("Token refresh failed, user may need to log in again.", refreshError);
            });
        } else {
          console.error("Error fetching documents:", error);
        }
      } 
    }
  };

  function uploadFileFromUrl(fileUrl, uploadEndpoint) {
    fetch(fileUrl)
      .then(response => response.blob())
      .then(blob => {
          const file = new File([blob], "uploadedFile.pdf", { type: blob.type });
          const formData = new FormData();
          dispatch(uploadDocument({ token: pdfEditortoken?.access, file }));
          navigate("/esign/new-esign", { replace: true });
      })
      .catch(error => console.error("Error fetching file:", error));
  }

  const handlePreview = async () => {
    if(doc?.pdf_path)
    {
      if(doc?.document_id)
      {
        setLoader(true)
        if(doc?.is_uploaded_to_s3)
        {
          console.log(doc)
          const payload = {
            "file_name": `${doc?.pdf_path}`
          };
          try {
            const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/download_pdf_file_from_s3`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload),
            });
    
            if (!response.ok) {
              setLoader(false);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
        
            const data = await response.json();
            console.log(data)
            const documentUrl = data.url;

              if (!documentUrl) {
                setLoader(false);
                toast.info(`Not Found: document url not found`);
                return;
              }
              const checkResponse = await fetch(documentUrl, { method: 'GET' });
              if (!checkResponse.ok) {
                setLoader(false);
                toast.info(`Not Found: document url not found`);
                return;
              }
              var previewDocumnetData = {document_url: documentUrl, document_name: doc?.document_name}
              setPreviewDocument(true)
              setPreviewDoc(previewDocumnetData)
              setLoader(false);
          }
          catch (error) {
            console.error('Error occurred while fetching the URL:', error.message);
            setLoader(false);
          }
        }
        else
        {
          const documentUrl = `${apiEndpoint.esignBaseUri}/${doc?.pdf_path}`;
          if (!documentUrl) {
            setLoader(false);
            console.error("Document URL not found in response.");
            return;
          }
          const checkResponse = await fetch(documentUrl, { method: 'GET' });
          if (!checkResponse.ok) {
            setLoader(false);
            console.error(`Document not found: ${documentUrl}`);
            return;
          }
          var previewDocumnetData = {document_url: `${apiEndpoint.esignBaseUri}/${doc?.pdf_path}`, document_name: doc?.document_name};
          setPreviewDocument(true);
          setPreviewDoc(previewDocumnetData);
          setLoader(false);
        }
      }
    }
    else {
      toast.info(`Not Found: document not found`);
    }
  };

  const copyUrl = () => {
    if (selectedSigner?.esign_link) {
      navigator.clipboard.writeText(selectedSigner.esign_link)
        .then(() => {
          toast.success("Link copied successfully!");
        })
        .catch((err) => {
          toast.error('Failed to copy');
          console.error('Failed to copy: ', err);
        });
    }
  }

  const maskEmail = (email) => {
    const [username, domain] = email.split("@");
    if (username.length <= 6) {
      return `${username[0]}***${username[username.length - 1]}@${domain}`;
    }
    const start = username.slice(0, 3);
    const end = username.slice(-3);
    // const masked = "*".repeat(username.length - 6);
    const masked = "******";
    return `${start}${masked}${end}@${domain}`;
  };
  
  const handleDownload = async () => {
    logEvent('Clicked', 'Download Button Clicked', 'Document Detail');
    if(doc?.pdf_path)
    {
      if(doc?.is_uploaded_to_s3)
      {
        setLoader(true);
        const payload = {
          "file_name": `${doc?.pdf_path}`
        };
        try {
          const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/download_pdf_file_from_s3`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            setLoader(false);
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
      
          const data = await response.json();
          console.log(data)
          const URLdata = data.url;
          var responsefile = await fetch(URLdata);
          if (!responsefile.ok) {
            setLoader(false);
            throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
          }

          const blob = await responsefile.blob();
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          var fileName = "pdfForEsign_signedFinal";
          const file_extension = "pdf"
          a.download = fileName + '.' + file_extension;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          setLoader(false);

        } catch (error) {
          console.error('Error occurred while fetching the URL:', error.message);
          setLoader(false);
        }
      }
      else
      {
        setLoader(true);
        let URLdata = `${apiEndpoint.esignBaseUri}/${doc?.pdf_path}`;
        var responsefile = await fetch(URLdata);
        if (!responsefile.ok) {
          setLoader(false);
          throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
        }

        const blob = await responsefile.blob();
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        var fileName = doc?.document_name;
        const file_extension = "pdf"
        a.download = fileName + '.' + file_extension;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        setLoader(false);
      }
    }
    else
    {
      toast.info("PDF Not Found")
    }
  };

  const handleIconClick = (signer) =>{
    setOpenQuickLook(true);
    setSelectedSigner(signer);
  }

  const handleAuditTrail = async () => {
    logEvent('Clicked', 'Audit Trail Button Clicked', 'Document Detail');
    if(selectedSigner?.uuid)
    {
      setLoader(true);
      const payload = {
        "event_name": `signers`
      };
      try {
        const response = await fetch(`${apiEndpoint.esignBaseUri}/EsignServices/auditTrail/${selectedSigner?.uuid}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          setLoader(false);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
        console.log(data)
        const URLdata = data.url;
        var responsefile = await fetch(URLdata);
        if (!responsefile.ok) {
          setLoader(false);
          throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
        }

        const blob = await responsefile.blob();
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        var fileName = "Audit Trail";
        const file_extension = "pdf"
        a.download = fileName + '.' + file_extension;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        setLoader(false);

      } catch (error) {
        console.error('Error occurred while fetching the URL:', error.message);
        setLoader(false);
      }
    }
  };
  
  return (<>
      <Box
        sx={{
          flexGrow: 1,
          p: "0",
          width: open ? "calc(100% - 288px)" : "calc(100% - 164px)",
          transition: "margin 0.3s ease",
          height: "calc(100% - 103px)",
          display: "flex",
          background: "#f9f9f9",
          gap: 3,
          position: "absolute",
          top: 103,
        }} 
      >
          <Box
              mt={10}
              style={{
              borderRadius: '12px',
              textAlign: 'center',
              background: '#fff',
              width: "100%",
              height: "calc(100% - 136px)",
              marginTop: 0,
              }}
          >
              <Box sx={{ height: '80px', display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 2em" }}>
                  <Box sx={{ display: "flex", cursor: "pointer" }} onClick={() => setOpenDetails(false)} >
                      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 18L2 10L9 2" stroke="#2556AB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                          {doc?.document_name?.length > 35 ? doc?.document_name.slice(0, 20) + "..." : doc?.document_name}
                      </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap:2.5 }} >
                    <Button variant="contained" sx={{ width: '156px', height: 40, color: "#FFFFFF", background: "#185CB7", textTransform: "none", fontSize: "14px", borderRadius: "8px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", position: "relative", "&:disabled": {background: "#ffffff", color: "#8DB0E2", borderColor: "#8DB0E2"}}} disabled>
                        Remind Signers
                        <Box sx={{ position: "absolute", top: "-13px", background: "linear-gradient(90deg, #FD1573 0%, #FF7309 100%)", width: 82, height: 24, borderRadius: "6px", fontSize: "12px", display: "flex", justifyContent: "center", alignItems: "center", color: "#FFFFFF" }}>
                          UPGRADE
                        </Box>
                    </Button>
                    <Button variant="contained" sx={{ minWidth: 40, height: 40, background: "#FFFFFF", borderRadius: "8px", border: "1px solid #E4E4E4", boxShadow: "none", p:0, }} onClick={() => {handlePreview();}} >
                      {esignIcons.eyeIcon}
                    </Button>
                    <Button variant="contained" sx={{ minWidth: 40, height: 40, background: "#FFFFFF", borderRadius: "8px", border: "1px solid #E4E4E4", boxShadow: "none", p:0,}} onClick={() => handleDownload()} >
                      {esignIcons.downloadIcon}
                    </Button>
                    <Button variant="contained" sx={{ minWidth: 40, height: 40, background: "#FFFFFF", borderRadius: "8px", border: "1px solid #E4E4E4", boxShadow: "none", p:0,}} onClick={(e) => handleSignerMenuOpen(e, doc)} >
                      {esignIcons.moreIcon}
                    </Button>
                  </Box>
              </Box>
              <Divider sx={{ borderWidth : "1px" }} />
              <Box sx={{ borderRadius: '12px', textAlign: 'center', background: '#fff', width: "100%", height: "calc(100% - -30px)", alignItems: "center", gap: 2, p: "20px", display: "flex", flexDirection: "row", }} >
                <Box sx={{ width: "35%", height: "100%", overflow: "auto" }}>

                  {signersStatus && signersStatus.map((signer, index) => {                    
                    const statusStyles = getStatusStyles(signer?.name_mismatch_error ? "failed" : signer.status);
                    return (
                      <Card key={signer.uuid} sx={{ mb: 2, borderRadius: '12px', boxShadow: "none", width: 360, height: "160px", background: "#FFFFFF", border: "1px solid #DFDFDF", display: "flex", flexDirection: "column", justifyContent: "space-between", overflow: "hidden", position: "relative" }}>
                          <Box sx={{textAlign: "left", padding: "20px 0 0 20px" }}>
                            <Typography variant="caption" sx={{ fontSize: "12px", fontWeight: "500", color: "#185CB7" }}>
                                SIGNER {(index + 1).toString().padStart(2, "0")}
                            </Typography>
                            <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: "600", color: "#1D1D1D" }}>
                                {signer.name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "300", color: "#5C5C5C" }} >
                                {maskEmail(signer.email)}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "12px", fontWeight: "300", color: "#5C5C5C", m: "5px 0" }} >
                                <b style={{ fontWeight: "500", color: "#1D1D1D" }}>Expiry Date:</b> {new Date(signer.expiry_date).toLocaleString()}
                            </Typography>
                          </Box>
                          
                          <Divider sx={{ mt: "auto", borderWidth: "1px" }}/>
                          <Box sx={{ display:"flex", alignItems:"center", justifyContent: "space-between", background: statusStyles.backgroundColor, height: 42, padding: "8px 20px", borderRadius: "0 0 10px 10px" }}>
                            <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "500", color: "#1D1D1D" }} >
                              {signer.esign_type_new==='digital-signature' ? `Digital Signature` : `Aadhaar eSign`}
                            </Typography>
                            <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "500", color: statusStyles.color, display: "flex", alignItems: "center", gap: "6px" }} >
                              {
                                signer?.name_mismatch_error ? (<SpeechTooltip name_mismatch_error={signer?.name_mismatch_error}/>) : 
                                (<span dangerouslySetInnerHTML={{ __html: statusStyles.icon }} style={{ display: "flex" }} />)
                              }
                              {signer?.name_mismatch_error ? "Failed" : signer.status}
                            </Typography>
                          </Box>
                          <Box sx={{ position: "absolute", right: 24, top: 30, display: "flex", alignItems: "center", gap: "2px" }}>
                              {signer.capture_image && (
                                signer.facefinder_done ? (
                                  <Tooltip title="View Verification" arrow>
                                    <img
                                      src={`${process.env.PUBLIC_URL}/images/ipv_done.svg`}
                                      alt="esignIcon"
                                      style={{ height: 28, cursor: 'pointer' }}
                                      onClick={() => handleIconClick(signer)}
                                    />
                                  </Tooltip>
                                ) : (
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/ipv_disabled.svg`}
                                    alt="esignIcon"
                                    style={{ height: 28, cursor: 'not-allowed' }}
                                  />
                                )
                              )}

                              <Box sx={{ cursor: 'pointer', display: "flex" }} onClick={(e) => handleMenuOpen(e, signer)} >
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 16C12.1046 16 13 16.8954 13 18C13 19.1046 12.1046 20 11 20C9.89543 20 9 19.1046 9 18C9 16.8954 9.89543 16 11 16ZM11 9C12.1046 9 13 9.89543 13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9ZM11 2C12.1046 2 13 2.89543 13 4C13 5.10457 12.1046 6 11 6C9.89543 6 9 5.10457 9 4C9 2.89543 9.89543 2 11 2Z" fill="#222222"/>
                                </svg>
                              </Box>
                          </Box>
                      </Card>
                    );
                  })}
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} PaperProps={{
                          sx: {
                              minHeight: "74px",
                              width: "168px",
                              borderRadius: "10px",
                              overflow: "hidden",
                          },
                      }}
                      anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center", 
                      }}
                      transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                      }}
                  >
                      <MenuItem 
                        onClick={copyUrl} 
                        sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: "3px" }}
                        disabled={!selectedSigner?.esign_link || selectedSigner?.status?.toLowerCase() === "completed" || selectedSigner?.status?.toLowerCase() === "expired"}
                      >
                        {esignIcons.copyIcon} Copy eSign Link
                      </MenuItem>
                     <MenuItem 
                        onClick={handleExpireOpen} 
                        sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: "3px" }}
                        disabled={selectedSigner?.status?.toLowerCase() === "completed" || selectedSigner?.status?.toLowerCase() === "expired"}
                      >
                        {esignIcons.expireIcon} Expire Request
                      </MenuItem>
                      <MenuItem 
                        onClick={handleSendReminder} 
                        sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: "3px" }}
                        disabled={!selectedSigner?.esign_link || selectedSigner?.status?.toLowerCase() === "completed" || selectedSigner?.status?.toLowerCase() === "expired"}
                      >
                        {esignIcons.sendReminder} Send Reminder
                      </MenuItem>
                      <MenuItem 
                        onClick={handleAuditTrail} 
                        sx={{ fontSize: "14px", fontWeight: "400", color: "#5C5C5C", gap: 1, pt: "3px" }}
                      >
                        {esignIcons.auditTrail} Audit Trail
                      </MenuItem>
                  </Menu>

                </Box>
                <Box sx={{ width: "65%", height: "100%", background: "#F9F9F9", overflow: "auto" }}></Box>
              </Box>
          </Box>
      </Box>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handlesignerMenuClose}
        PaperProps={{
            sx: {
                height: "42px",
                width: "168px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                overflow: "hidden",
            },
        }}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center", 
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
      >
        <MenuItem onClick={handleNewRequest} sx={{ fontSize: "14px", fontWeight: "400", color: "##5C5C5C", gap: 1, pt: "3px" }} disabled={!["completed", "expired"].includes(doc?.status?.toLowerCase())}>{esignIcons.editIcon} New Request</MenuItem>
        <Divider sx={{ width: "85%", justifySelf: "end" }} />
      </Menu>
      {loader && <Loader />}
      {previewDocument && <PdfPreview previewDoc={previewDoc} setPreviewDoc={setPreviewDoc} previewDocument={previewDocument} setPreviewDocument={setPreviewDocument} />}
      <QuickLookModal
        open={openQuickLook}
        onClose={() => setOpenQuickLook(false)}
        selectedSigner={selectedSigner}
        setSelectedSigner={setSelectedSigner}
      />

      <Modal open={expireRequestOpen} onClose={() => setExpireRequestOpen(false)}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "434px", height: "368px", backgroundColor: "#fff", boxShadow: 24, overflow: "auto", borderRadius: "20px",}}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Expire Request</Typography>
            </Box>
            <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
            <Box sx={{ p: "23px 34px", mb: "9px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "calc(100% - 77px)" }}>
                <Box>
                    <img src={`${process.env.PUBLIC_URL}/images/expire.svg`} alt="expire" style={{ height: 83 }} />
                </Box>
                <Typography sx={{ fontSize: "20px", fontWeight: 400, color: "#1D1D1D", lineHeight: "32px", mt: "auto" }}>
                  Are you sure you want to expire this request?
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: "auto", gap: 2 }}>
                    <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => setExpireRequestOpen(false)} >
                        No
                    </Button>
                    <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#EA464A", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #EA464A", boxShadow: "none", fontWeight: "500",}} onClick={handleExpire} >
                        Yes
                    </Button>
                </Box>
            </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DocumentDetails;
